import { PropTypes } from "prop-types"
import classNames from "classnames"
import _ from "lodash"

import Translate from "../Translate"

export function IconRating(props) {
  const { classes, rating, type, showOverMax = false, maxRating = 5, ariaHidden = false } = props

  const renderIcon = (className, key) => {
    return (
      <span key={key} className={classNames(className, _.kebabCase(type))} role="presentation" />
    )
  }

  const isHalfRating = !Number.isInteger(Number(rating))

  return (
    <Translate>
      {({ translate }) => {
        const accessibilityText = translate(`accessIconRating-${type}`, { rating })
        return (
          <div
            className={classNames("oj-icon-rating", classes)}
            title={accessibilityText}
            aria-hidden={ariaHidden}
          >
            <span className="accessibility-tag">{accessibilityText}</span>
            {_.times(_.floor(rating), key => renderIcon("full-rating", key))}
            {isHalfRating && renderIcon("half-rating")}
            {showOverMax &&
              _.times(_.floor(maxRating - rating), key =>
                renderIcon("full-rating state-disabled", key)
              )}
          </div>
        )
      }}
    </Translate>
  )
}

IconRating.propTypes = {
  type: PropTypes.string.isRequired,
  classes: PropTypes.string,
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxRating: PropTypes.number,
  showOverMax: PropTypes.bool,
  ariaHidden: PropTypes.bool
}

export default IconRating
